import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="w-full px-4 md:px-8 py-20 md:py-28 flex flex-col items-center text-center">
      <span className="w-20 h-20 rounded-full bg-background-100 text-background-400 flex items-center justify-center mb-6">
        <i className="ri-emotion-sad-line text-4xl"></i>
      </span>
      <p className="font-heading font-black text-5xl md:text-6xl text-primary-500">404</p>
      <h1 className="mt-4 font-heading font-bold text-xl md:text-2xl text-foreground-950">
        抱歉，没有找到这个页面
      </h1>
      <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-md">
        你访问的页面可能已被移动或删除，试试从下面的入口重新开始吧。
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="h-11 px-5 rounded-md bg-accent-500 hover:bg-accent-600 text-background-50 text-sm font-medium whitespace-nowrap flex items-center gap-2 transition-colors cursor-pointer"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/search"
          className="h-11 px-5 rounded-md bg-background-100 hover:bg-background-200 text-foreground-800 text-sm font-medium whitespace-nowrap flex items-center gap-2 transition-colors cursor-pointer"
        >
          <i className="ri-search-line"></i>
          搜索影视内容
        </Link>
      </div>
    </div>
  );
}